/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ExamLangsId202,
  DeleteApiV1ExamLangsId401,
  DeleteApiV1ExamLangsId404,
  DeleteApiV1ExamLangsId500,
  DeleteApiV1ExamLangsIdMutationResponse,
  DeleteApiV1ExamLangsIdPathParams,
} from "../../types/examEvaluationController/DeleteApiV1ExamLangsId.ts";

export const deleteApiV1ExamLangsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ExamLangsIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ExamLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ExamLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ExamLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ExamLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamLangsId500>;

export const deleteApiV1ExamLangsIdMutationResponseSchema = z.lazy(
  () => deleteApiV1ExamLangsId202Schema,
) as unknown as ToZod<DeleteApiV1ExamLangsIdMutationResponse>;
